import React, { useId } from 'react';
import './Badge.css';

/**
 * The rotating seal from the frame: a motto set on a circular path with a
 * solid pine dot at the centre.
 *
 * Motivation: it is the one perpetually moving thing on the page. It sits
 * in the hero's empty upper-left and signals the site is live without
 * competing with the headline. Text is on an SVG textPath rather than
 * per-letter transforms, so it stays selectable and screen-reader legible.
 */
function Badge({ text = 'Dream big. Work hard. Ship it.' }) {
  const id = useId();
  const pathId = `badge-path-${id.replace(/:/g, '')}`;

  // Trailing space keeps the loop from butting the first letter against
  // the last one where the path closes.
  const ring = `${text.toUpperCase()} `;

  return (
    <div className="badge" role="img" aria-label={text}>
      <svg className="badge__ring" viewBox="0 0 200 200" aria-hidden="true">
        <defs>
          <path
            id={pathId}
            d="M100,100 m-74,0 a74,74 0 1,1 148,0 a74,74 0 1,1 -148,0"
            fill="none"
          />
        </defs>
        <text className="badge__text">
          <textPath href={`#${pathId}`} startOffset="0">
            {ring}
          </textPath>
        </text>
      </svg>

      <span className="badge__dot" aria-hidden="true" />
    </div>
  );
}

export default Badge;
